<template>
  <div v-if="isLoading">
    <LoadingPlaceholder/>
  </div>
  <div v-else>
    <Breadcrumbs
      :breadcrumbs="[
     {title: this.$t(`menu.${serviceSlug}`), disabled: true},
     {title: this.$t('menu.iframe/blocks-builder'), active: true, meta: {type: 'string', value: `/${this.iframeService.slug}/${this.iframeService.slug}/blocks-builder`}},
     {title: $t('iframe.page_types.anamnese_page'), disabled: true},
     {title: block.name, disabled: true}
   ]"/>

    <div>
      <h5 class="text-evollu-gray-light is-bold mb-0 pl-3 py-3"> {{$t('iframe.titles.update_block', {name: block.name})}} </h5>

      <BlockDetails
        v-model="blockForm"
        :form-errors="blockErrors"
        :clientOptions="clientOptions"
      />
    </div>

    <!-- Buttons row -->
    <div class="row d-flex justify--space-between mt-3 ml-3 mr-3">
      <va-button class="btn-cancel" @click="handleCancel">
        {{$t('iframe.actions.cancel')}}
      </va-button>

      <va-button @click="handleSave" :disabled="!canSubmit">
        {{$t('iframe.actions.save')}}
      </va-button>
    </div>
    <!-- --- --- --- -->

  </div>
</template>

<script>
import Breadcrumbs from "@/components/common/Breadcrumbs";
import LoadingPlaceholder from "@/components/common/LoadingPlaceholder";
import IframeBlocksUpdateMixin from "@/mixins/IframeBlocksUpdateMixin";
import BlockDetails from "@/components/iframe/blocks-builder/anamnese/BlockDetails";
import Errors from "@/utils/StandardErrors";
import {IframeService} from "@/api/IframeService";

const errorsPrefix = 'iframe.blocks_builder.questionnaire_block.errors.'

export default {
  mixins: [IframeBlocksUpdateMixin],
  components: {BlockDetails, LoadingPlaceholder, Breadcrumbs},
  props: {
    serviceSlug: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      isLoading: true,
      isSubmiting: false,
      blockForm:{
        name: null,
        lang: null,
        title: null,
        subtitle: null,
        evohealth_anamnese_id: null,
        client: null
      },
      block: null,
      blockErrors: new Errors()
    }
  },

  methods: {
    handleSave: function() {
      if(this.canSubmit) {
        this.isSubmiting = true
        let formDataToSubmit = {...this.blockForm}
        if(this.blockForm.lang) {
          formDataToSubmit.lang = this.blockForm.lang.lang
        }

        formDataToSubmit.evohealth_anamnese_id = formDataToSubmit.evohealth_anamnese_id.id

        if(this.blockForm.client) {
          formDataToSubmit.client_id = this.blockForm.client.id
        }

        IframeService.updateAnamnesePage(this.block.id, formDataToSubmit)
          .then(res => {
            this.showToast(this.$t('iframe.blocks_builder.updated'), this.$store.state.successToastOptions)
            this.handleCancel()
          })
          .catch(errors => {
            if(errors.response.status === 422) {
              this.blockErrors.record(errors.response.data.errors, errorsPrefix)
            }
            this.showToast(this.$t('iframe.blocks_builder.update_error'), this.$store.state.errorToastOptions)
          })
          .finally(() => {
            this.isSubmiting = false
          })
      }
    }
  },
  computed: {
    canSubmit() {
      return (this.blockForm.name !== null && this.blockForm.name !== '')
        && (this.blockForm.title !== null && this.blockForm.title !== '')
        && (this.blockForm.subtitle !== null && this.blockForm.subtitle !== '')
        && this.blockForm.evohealth_anamnese_id !== null
        && !this.isSubmiting
      && this.blockForm.client !== null
    },
    iframeService: function () {
      return this.$store.state.services.find(service => service.slug === 'iframe') || null
    },
    clientOptions: function () {
      if (this.iframeService) {
        if (this.iframeService.user_permissions.some(perm => perm.entity_id === null)) {
          return this.iframeService.entities
        }
        const consideredEntitiesIds = this.iframeService.user_permissions.filter(perm => perm.access_type >= 1 && perm.info_type === 120).map(elem => elem.entity_id)
        return this.iframeService.entities.filter(entity =>  consideredEntitiesIds.includes(entity.id))
      }
      return []
    },
  }
}
</script>

<style scoped>

</style>
